import { useEffect, useRef } from "react";
import Quill from "quill";

const QuillEditorViewOnly = ({ value }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    const quill = new Quill(editorRef.current, {
      theme: "snow", // Use the snow theme
      readOnly: true, // Set editor to read-only
      modules: {
        toolbar: false, // Disable the toolbar
      },
    });

    // Set initial content
    if (typeof value === "string") {
      quill.clipboard.dangerouslyPasteHTML(value?.trim());
    }

    // Handle content change
    quill.on("text-change", () => {
      const content = quill.root.innerHTML;
      onChange(content);
    });

    // editorRef.current = quill;

    return () => {
      quill.off("text-change");
    };
  }, [value]);

  return (
    <div className="quill-view-only">
      <style>
        {`
          .quill-view-only .ql-container {
            border: none !important;
            box-shadow: none !important;
          }
          .quill-view-only .ql-editor {
            padding: 0;
            margin: 0;
          }
        `}
      </style>
      <div ref={editorRef} className="font-medium text-charcoal" />
    </div>
  );
};

export default QuillEditorViewOnly;
